module.exports = once

once.proto = once(function () {
  Object.defineProperty(Function.prototype, 'once', {
    value: function () {
      return once(this)
    },
    configurable: true
  })
})

function once (fn) {
  var called = false
  return function () {
    if (called) return
    called = true
    return fn.apply(this, arguments)
  }
}



//////////////////
// WEBPACK FOOTER
// ./~/xhr/~/once/once.js
// module id = 85
// module chunks = 0 1